import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectBridgeSlice } from '../redux/slices/bridgeSlice';

interface TransactionProgress {
  step: '4-1' | '4-2' | '4-3' | 'failed';
  status: 'waiting' | 'success';
}

const useTransactionProgress = (): TransactionProgress => {
  const { txCurrentHistory } = useSelector(selectBridgeSlice);

  return useMemo(() => {
    if (txCurrentHistory) {
      // To체인 승인(출금) 완료
      if (txCurrentHistory.toChainHtlcState === `withdrawn`) {
        return {
          step: `4-3`,
          status: `success`,
        };
      }
      // (전환완료) To체인 승인 필요
      if (txCurrentHistory.toChainHtlcState === `mirrored`) {
        return {
          step: `4-3`,
          status: `waiting`,
        };
      }

      // ISSUE : fromChainHtlcState pending 상태가 fromChain에서 사용자가 newContract 완료한 상태임
      if (txCurrentHistory.fromChainHtlcState === `newContract`) {
        // 전환중
        return {
          step: `4-2`,
          status: `waiting`,
        };
      }
    }

    return {
      step: `4-1`,
      status: `waiting`,
    };
  }, [txCurrentHistory]);
};

export default useTransactionProgress;
